import styled from '@emotion/styled';
import { theme } from '@ublend-npm/aulaui-next';

export const EditorWrapper = styled.div<{ isReadOnly: boolean }>`
  font-family: ${theme.font.family.workSans};
  color: ${theme.color.designSystem.blackOpacity87};
  width: 100%;

  p {
    font-size: ${theme.font.size.copy};
    line-height: ${theme.font.lineHeight.copy};
    margin-top: ${({ isReadOnly }) =>
      isReadOnly ? theme.spacing.large : theme.spacing.xSmall};
    margin-bottom: ${({ isReadOnly }) =>
      isReadOnly ? theme.spacing.large : theme.spacing.xSmall};
  }

  h1 {
    font-size: 24px;
  }
  h2 {
    font-size: 20px;
  }
  h3 {
    font-size: 16px;
  }

  h1,
  h2,
  h3 {
    line-height: 1.3em;
    font-weight: ${theme.font.weight.semiBold};
  }

  & *::selection {
    background-color: ${theme.color.designSystem.background.purpleAlpha(0.7)};
  }

  blockquote {
    margin: ${theme.spacing.xxSmall} 0;
    padding-left: ${theme.spacing.small};
    border-left: 2px solid ${theme.color.designSystem.blackOpacity38};
    font-style: italic;
    font-weight: ${theme.font.weight.regular};
    font-size: ${theme.font.size.copy};
    line-height: ${theme.font.lineHeight.copy};
    color: ${theme.color.designSystem.blackOpacity60};
  }
`;

export const ControlsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-left: 20px;
`;
